import { Component, OnInit, AfterViewInit, OnChanges, SimpleChange, Input, OnDestroy, HostListener, Renderer2, ElementRef } from '@angular/core';
import { CustomTabs, CustomTabsOptions } from './custom-tabs';
import { EventType, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { trigger, transition, style, animate } from '@angular/animations';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-custom-tabs',
  templateUrl: './custom-tabs.component.html',
  styleUrls: ['./custom-tabs.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [
        style({ overflow: 'hidden', height: '0', opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden', height: '*', opacity: 1 }),
        animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '0', opacity: 0})),
      ]),
    ]),
  ]
})
export class CustomTabsComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() fields: CustomTabs[] = [];
  @Input() options: CustomTabsOptions | undefined;


  active: string = /[^/;]+(?=;|$)/.exec(this.router.url)![0];

  parsedFields: Array<CustomTabs> = [];

  // unsubscribe subscriptions
  private theEnd$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router, private renderer: Renderer2, private el: ElementRef, private globalS: GlobalService
  ) {
    //this.parsedFields = this.fields;    
  }

  isMobile: boolean = true;

  current?: CustomTabs;

  previous?: CustomTabs;

  next?: CustomTabs;

  showList: boolean = false;




  ngOnInit(): void {
    this.activateTab();
    console.error(this.fields)
    this.router.events.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (event: any) => {
        if (event instanceof NavigationEnd) {
          // to the thinghs to set tab active based on url
          this.setActiveState(event);
        }
      }
    });

    this.isMobile = this.globalS.isMobile();

    this.globalS.isMobile$.pipe(takeUntil(this.theEnd$)).subscribe(isMobile=>{
      this.isMobile = isMobile;
    })
  }


  // Function to handle element selection
  selectElement(id: string) {
    
    const selectedElement = this.el.nativeElement.querySelector(`#${id}`);

    console.warn(selectedElement)
    // Remove 'selected' class from any previously selected element
    const previousSelected = this.el.nativeElement.querySelector('.selected');
    if (previousSelected) {
      this.renderer.removeClass(previousSelected, 'selected');
    }

    // Add 'selected' class to the clicked element
    this.renderer.addClass(selectedElement, 'selected');

    // Get the position and width of the clicked element
    const rect = selectedElement.getBoundingClientRect();
    const container = this.el.nativeElement.querySelector('.element-container');
    const containerRect = container.getBoundingClientRect();

    // Update the sliding background position and size
    //  this.renderer.setStyle(container, '--slide-left', `${rect.left - containerRect.left}px`);

    document.documentElement.style.setProperty('--slide-left', `${rect.left - containerRect.left}px`);

    //this.renderer.setStyle(container, '--slide-width', `${rect.width}px`);

    document.documentElement.style.setProperty('--slide-width', `${rect.width}px`);

    console.log(`${rect.left - containerRect.left}px`)

    console.log(`${rect.width}px`)



  }
  /**
   * Change the active tab based on last part of the url
   * @param event NavigationStart: data from router 
   */
  setActiveState(event: NavigationEnd) {
    console.warn(event);
    // get the last part from url
    var result = /[^/;]+(?=;|$)/.exec(event.url)![0];
    //console.error(result);
    // check if the last part is in the array
    let i = this.fields.find(x => x.routerOutlet.includes(result));
    // is it?
    console.log("in set active");
    console.log(i);
    if (i != undefined) {
      // if it is give the active status to the required field
      let index = this.fields.indexOf(i);

      console.log("its includded");
      this.active = i.routerOutlet;

      
      this.current = i;
      this.previous = this.fields[index - 1] || undefined
      this.next = this.fields[index + 1] || undefined
      if(!this.isMobile){

        this.selectElement(this.active);
      }
      //console.error(this.active);
    }
  }

  navigateToPage(routerOutlet: string, routerParams: any) {
    let urlArr = this.router.url.split('/')
    urlArr.pop();

    // if the last element of the array is one from the list remove it
    let lastIndex = urlArr.length-1;

    let exist = this.fields.findIndex(x => x.routerOutlet == urlArr[lastIndex]);

    if(exist > -1) {
      urlArr.pop();
    }
    

    urlArr.push(routerOutlet)
    let url = '';

    urlArr.forEach((x, i) => {
      url += `${x}/`
    })

    if (routerParams != undefined) {

      this.router.navigate([url, routerParams]);
    } else {
      this.router.navigate([url]);
    }
  }

  /**
   * Disable all the tabs that need to be disabled
   */
  disableTabs(): void {
    setTimeout(() => {
      for (let i = 0; i < this.fields.length; i++) {
        let t = document.getElementById(this.fields[i].title) as HTMLButtonElement;
        //console.log(t);
        if (t != null) {
          if (this.fields[i]!.disabled == true) {
            t!.disabled = true;
          } else {
            t!.disabled = false;
          }
        }
      }
    }, 10);
  }

  /**
   * Redirect to active tab
   */
  activateTab() {
    var res = this.fields.find(x => x.active == true);
    var result = /[^/;]+(?=;|$)/.exec(this.router.url)![0];
    console.log(res);
    console.log(result);
    if (res != undefined) {
      if (res.routerOutlet != result) {
        this.router.navigate([`${this.router.url}/${res.routerOutlet}`]);
      }
    } else {
      //check inside valid routes
      setTimeout(() => {
        
        this.fields.forEach((x) => {
          console.error('ROUTE')
          console.warn(x.routerOutlet);
          if (x.validRoutes != undefined) {
            x.validRoutes?.forEach((y) => {
              console.error('VALIDROUTE')
              console.warn(y);
              console.warn(result);
              if(result == y){
                this.active = x.routerOutlet;
                this.selectElement(this.active);
                this.current = x;
              }
            })
          }
        })
      }, 500);
      // better do nothing 
      /*if(this.fields[0].routerOutlet != result) {
        this.router.navigate([`${this.router.url}/${this.fields[0].routerOutlet}`]);
      }*/
    }
  }

  /**
   * Return the correct background for the tab
   */
  getTabBackground(tab: CustomTabs): string {
    // if not active dont need to show color
    if (tab.routerOutlet == this.active) {
      if (tab.background == undefined || null) {
        if (this.options?.background != undefined || this.options?.background != null) {
          // color for all tabs is setted        
          return this.options.background;
        } else {
          // return default color
          return 'var(--color-primary-500)';
        }
        // tab background is setted
      } else {
        return tab.background;
      }
    } else {
      return 'rgba(255,255,255,0.0)';
    }
  }

  /**
   * return the correct color for the tab
   */
  getTabColor(tab: CustomTabs): string {
    // if not active dont need to show color
    if (tab.routerOutlet == this.active) {
      if (tab.color == undefined || null) {
        if (this.options?.color != undefined || this.options?.color != null) {
          // color for all tabs is setted        
          return this.options.color;
        } else {
          if (tab.disabled == true) {
            return 'var(--color-primary-disabled)';
          }
          // return default color
          return '#ffffff';
        }
        // tab background is setted
      } else {
        return tab.color;
      }
    } else {
      if (tab.disabled == true) {
        return 'var(--color-primary-disabled)';
      }
      return '#000000';
    }
  }

  ngAfterViewInit(): void {
    console.log('AFTERVIEWINIT')
    let event: NavigationEnd = {
      id: 0,
      url: this.router.url,
      type: EventType.NavigationEnd,
      urlAfterRedirects: '',
    };


    this.selectElement(this.active);
    // activate tabs
    //this.setActiveState(event);
    // disable the tabs
    this.disableTabs();
    // set hover
    this.changeTabsHoverColor(this.fields);
  }

  changeTabsHoverColor(tabs: CustomTabs[]) {
    for (let i = 0; i < tabs.length; i++) {
      const tab = document.getElementById(tabs[i].title) as HTMLButtonElement;
      if (tab != undefined || null) {
        tab.style.setProperty('--tabs-bg-hover-color', tabs[i].background || this.options?.background || 'var(--color-primary-400)');
        tab.style.setProperty('--tabs-text-hover-color', '#ffffff');
      }
    }
  }

  ngOnChanges(changes: { fields: SimpleChange }): void {
    if (changes.fields) {
      this.parseField(changes.fields.currentValue);
      this.disableTabs();
      let event: NavigationEnd = {
        id: 0,
        url: this.router.url,
        type: EventType.NavigationEnd,
        urlAfterRedirects: '',
      };

      setTimeout(() => {

        this.setActiveState(event);
        this.changeTabsHoverColor(changes.fields.currentValue);



      }, 100);
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  parseField(fields: Array<CustomTabs>) {
    this.parsedFields = _.cloneDeep(fields);
  }

}

